import request from '@/utils/request'

export function getSettings() {
    return request({
      url: 'admin/getSettings',
      method: 'get'
    })
  }

  export function updateSettings(data) {
    return request({
      url: 'admin/updateSettings',
      method: 'post',
      data
    })
  }

  export function updateSettingsByField(data) {
    return request({
      url: 'admin/updateSettingsByField',
      method: 'post',
      data
    })
  }

  export function getSmsEmailConfig() {
    return request({
      url: 'admin/getSmsNotifications',
      method: 'get'
    })
  }

  export function updateSmsEmailConfig(data) {
    return request({
      url: 'admin/updateSmsNotifications',
      method: 'post',
      data
    })
  } 

  export function getEventSmsEmailConfig(data) {
    return request({
      url: '/admin/getSmsEmailEvents/' + data,
      method: 'get'
    })
  }

  export function updateEventSmsEmailConfig(data) {
    return request({
      url: 'admin/updateSmsEmailEvents',
      method: 'post',
      data
    })
  } 

  export function updateNotifications(data) {
    return request({
      url: 'admin/eventNotification',
      method: 'post',
      data
    })
  } 

  export function smsEmailEventSetting(data) {
    return request({
      url: 'admin/smsEmailEventSetting',
      method: 'post',
      data
    })
  } 

  export function customNotification(data) {
    return request({
      url: '/admin/customNotification',
      method: 'post',
      data
    })
  }

  export function getDesignConfig() {
    return request({
      url: 'getImageConfiguration',
      method: 'get'
    })
  }

  export function updateDesignConfig(data) {
    return request({
      url: 'imageConfiguration',
      method: 'post',
      data
    })
  }

  export function getAssets(data) {
    return request({
      url: '/getImage/' + data,
      method: 'get',
			maxAge: 5 * 60 * 1000 // cached for 5 mins
    })
  }

  export function changePassword(data) {
    return request({
      url: '/admin/changePassword',
      method: 'post',
      data
    })
  }

  export async function getTime() {
    return await request({
      url: '/getTime?utcOffset=' + (new Date).getTimezoneOffset()
    }) 
  }
